export default __webpack_public_path__ + "static/media/a011-example8.5e1d8418.jpg";